<template lang="pug">
  v-btn.participa-help.v-btn--xsmall(color="primary" :class="getClassName()" :flat="!header" :round="!header" :icon="header" @click.stop="$emit('on-click')")
    .span.participa-help-text(v-if="!showApHelpIcon") Ayuda
    i.ap-Help(v-if="showApHelpIcon")
    i.material-icons(v-if="!showApHelpIcon") help
</template>

<script>
export default {
  computed: {
    showApHelpIcon () {
      return this.header || this.footer
    }
  },
  methods: {
    getClassName () {
      return `${this.header ? 'is-in-header' : ''} ${this.footer ? 'is-in-footer' : ''} ${this.isInRoot && !this.header ? 'is-in-root' : ''}`
    }
  },
  props: {
    header: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'
.participa-help
  position: absolute
  width: 50px
  margin: 0
  top: 0
  right: 0
  &.is-in-header
    position: relative
  &.is-in-header,
  &.is-in-header:before
    width: 28px
    min-width: 28px
  &.is-in-root
    top: $f22px
    right: $f18px
    font-size: $f25px
  i.material-icons
    min-width: $f16px
    width: $f16px
    height: $f24px
    font-size: $f25px
    color: $color_0

  &.is-in-footer
    background-color: white
    margin-left: auto
    margin-right: 1rem
    min-width: 0
    position: relative
    width: 0
    .v-btn--xsmall.v-btn
      height: $f23px
      padding: 0 11px 0 12px !important

    i.ap-Help
      color: white !important
      font-size: $f20px

.participa-help-text
  color: $color_0
  text-transform: initial
  font-size: $f12px
  margin-right: 5px

</style>
